import xss from 'xss';
/**
 * stripXss takes in a string of html markup, stips xss and returns a sanitized string
 * @param  {string} markup
 * @returns {string}
 */
const stripXss = (markup) => {
    return xss(markup);
}

export default stripXss;
